var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/modules/_an-object.js
// module id = 234
// module chunks = 0